import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconLocationSvg } from "./IconLocationSvg.mjs";
const IconLocation = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconLocationSvg, ...svgProps }) });
export {
  IconLocation
};
